<template>
  <div>
    <handle-product-spec-sidebar ref="productSpecSidebar" />
    <handle-assign-template-sidebar ref="assignTemplateSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <venue-selector
          v-model="filterVenue"
          @venue="onVenueSelected"
          style="width: 350px"
          :filterCountries="[activeCountry.name]"
          :globalMode="true"
          :multiple="false"
        />
      </div>
      <div class="flex justify-end">
        <vs-button
          @click="onClickCreateNew"
          :disabled="isLoading"
          icon="add"
          class="mr-3"
          type="relief"
          color="primary"
          >Assign recipe to venue</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        v-if="!isLoading"
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        :max-items="12"
        :data="mappedProductSpecs"
        @selected="onClicked(selected.id)"
      >
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="createdBy.username">Created by</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img
                    v-if="tr.imageUrl && tr.imageUrl !== ''"
                    style="border-radius: 5px"
                    width="80"
                    :src="tr.imageUrl"
                  />
                  <img v-else width="40" :src="ProductIcon" />
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.name }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.createdBy">
                  {{ tr.createdBy.username }}
                </div>
              </vs-td>

              <vs-td>
                <div v-if="tr.createdAt" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.createdAt | formatDate }}
                </div>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="confirmDelete(tr.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div
        v-else
        class="
          mt-10
          my-auto
          vx-col
          flex
          items-center
          align-center
          justify-center
          flex-col
          sm:w-1/2
          md:w-3/5
          lg:w-2/4
          xl:w-2/4
          mx-auto
          text-center
        "
      >
        <img
          src="@/assets/images/no_venue_selected.png"
          alt="graphic-404"
          class="mx-auto mb-4"
          style="width: 150px"
        />
        <h5 class="sm:mx-0 mx-4 mt-4 text-xl d-theme-text">
          Select a venue to continue
        </h5>
        <!-- <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text">
            Select a venue to continue
          </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import VenueSelector from "@/components/VenueSelector.vue";
import HandleProductSpecSidebar from "./HandleProductSpecSidebar.vue";
import HandleAssignTemplateSidebar from "./HandleAssignTemplateSidebar.vue";

export default {
  components: {
    VenueSelector,
    HandleProductSpecSidebar,
    HandleAssignTemplateSidebar,
  },
  data() {
    return {
      filterVenue: null,
      currentVenue: null,
      isLoading: true,
      ProductIcon,
      selected: null,

      filters: {},

      selectableFilters: {},
    };
  },
  methods: {
    async onVenueSelected(venue) {
      console.log("Selected venue", venue);
      if (!venue) {
        this.currentVenue = null;
        this.isLoading = true;
        return;
      }
      this.currentVenue = venue;
      this.isLoading = true;
      await this.$store.dispatch(
        "pimVenues/getVenueProductSpecs",
        this.currentVenue.venueId
      );
      this.isLoading = false;
    },
    onClickCreateNew() {
      this.$refs.assignTemplateSidebar.showEmpty(this.currentVenue);
    },
    onClicked(id) {
      this.$refs.productSpecSidebar.show(id);
    },

    async confirmDelete(productSpecId) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to remove this recipe from the venue?`,
        accept: () => this.deleteProductSpec(productSpecId),
      });
    },
    async deleteProductSpec(productSpecId) {
      const dto = {
        productSpecIds: [productSpecId],
      };

      const result = await this.$store.dispatch(
        "pimVenues/unassignProductSpecs",
        {
          venueId: this.currentVenue.venueId,
          dto: dto,
        }
      );

      this.$vs.notify({
        title: "Recipe unassigned",
        text: "Recipe successfully unassigned from venue.",
      });

      // Wait 1 second
      await new Promise((resolve) => setTimeout(resolve, 1000));

      await this.$store.dispatch(
        "pimVenues/getVenueProductSpecs",
        this.currentVenue.venueId
      );

      this.isActive = false;
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters({
      productSpecs: "pimVenues/venueProductSpecs",
      activeCountry: "venues/activeCountry",
    }),

    mappedProductSpecs() {
      return this.productSpecs;
    },
  },

  async created() {},
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
